import t from "@/constants/wording"

import * as styles from "./new-version/index.module.scss"

export const SelectAttr = {
  isSearchable: false,
  maxMenuHeight: 216,
  className: styles.versionSelect,
  classNamePrefix: "select",
  placeholder: t("please choice"),
}

export interface IOption {
  label: string
  value: string
}

export interface IObjectKeys {
  [key: string]: string
}

export interface VersionOption extends IObjectKeys {
  label: string
  value: string
  serverLink: string
  toolkitLink: string
  serverLinkArm: string
  toolkitLinkArm: string
  manualChinese: string
  manualEnglish: string
}

export const getPlatformOptions = (value?: VersionOption) => {
  const result = []
  if (value) {
    result.push({ label: "x86, 64-bit", value: "x86" })
    if (value.serverLinkArm && value.toolkitLinkArm) {
      result.push({ label: "ARM, 64-bit", value: "arm" })
    }
  }
  return result
}
